import React from "react";
import styled from "styled-components";
import { border } from "@carvana/helios-styles";
import { mq, LARGE_MOBILE } from "../styles/mixins";

type LineProps = {
  margin?: string | number;
  height?: string;
  width?: string;
  hideOnMobile?: boolean;
};

const Horizontal = styled.div<LineProps>`
  border-top: 1px solid ${border.weak};
  margin: ${({ margin = "55px auto" }) => margin};
  width: ${({ width = "100%" }) => width};
  ${({ hideOnMobile }) => hideOnMobile && mq(LARGE_MOBILE, "display: none;")}
`;

const Vertical = styled.div<LineProps>`
  border-right: 1px solid ${border.weak};
  margin: ${({ margin = "auto 32px" }) => margin};
  height: ${({ height = "24px" }) => height};
`;

type Props = LineProps & {
  direction?: "horizontal" | "vertical";
};

const GrayLine = ({ direction = "horizontal", ...rest }: Props) => {
  return direction === "horizontal" ? (
    <Horizontal {...rest} />
  ) : (
    <Vertical {...rest} />
  );
};

export default GrayLine;
